import { FC } from 'react';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import styled from 'styled-components';
import { MODAL_NAMES } from 'modules/projectSettings/contexts';
import { useWhatsAppInfobipLocalesContext } from '../WhatsAppInfobipLocalesContext';
import { ProjectLocales } from './LocalesTable';
import { spacing } from 'ui/theme';
import { Add16 } from 'ui/icons/action/Add16';

const StyledButton = styled(Button)`
  margin-left: -${spacing.threeQuarter};
`;

export const LanguageTableCell: FC<{ row: ProjectLocales }> = ({ row }) => {
  const { whatsAppInfobipLocales } = useWhatsAppInfobipLocalesContext();

  return (
    <>
      {row.language ? (
        whatsAppInfobipLocales.find(({ value }) => value === row.language)?.label
      ) : (
        <StyledButton
          variant={BUTTON_VARIANTS.SECONDARY}
          size={BUTTON_SIZES.SMALL}
          onClick={() =>
            row.showModal({
              name: MODAL_NAMES.WA_LOCALE,
              payload: {
                locale: row.locale,
                language: row.language,
              },
            })
          }
        >
          <Add16 /> Add language
        </StyledButton>
      )}
    </>
  );
};
